exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".Footer{position:fixed;right:0;left:0;bottom:0;background-color:#fff;height:60px;text-align:center}.Footer .Footer__box{padding:20px}.Footer .Footer__title--fb{float:left;text-decoration:none;color:#000}.Footer .Footer__title--love{float:right;text-decoration:none;color:#000}.Footer .Footer__title--btn{margin-top:-40px;padding:20px 60px}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/less-loader!./src/components/Footer/Footer.less
 ** module id = 174
 ** module chunks = 0
 **/